import { takeEvery } from 'redux-saga/effects';
import {
  AUTHORIZED_CHECK,
  AUTHORIZED_LOGIN,
  AUTHORIZED_LOGOUT,
  AUTHORIZED_REGISTRATION, DELETE_NOTIFICATION,
  FORGOT_PASSWORD, LOAD_DOCUMENT_TYPES,
  LOAD_NOTIFICATION,
  LOAD_NOTIFICATION_TYPES,
  MARK_ALL,
  REFRESH_KEY_CLOAK,
  UPDATE_PASSWORD,
} from '../actions';
import { AUTHORIZED_MODULE, SYSTEM_MODULE } from '../../../configs/moduleNames';
import { INIT_APP } from '../../System/actions';
import { FAILED } from '../../../configs/actionNames';

import authorizedCheck from './authorizedCheck';
import authorizedLogin from './authorizedLogin';
import authorizedLogout from './authorizedLogout';
import authorizedRegistration from './authorizedRegistration';
import forgotPassword from './forgotPassword';
import initKeyCloak from './initKeyCloak';
import refreshKeyCloak from './refreshKeyCloak';
import updatePassword from './updatePassword';
import loadNotification from './loadNotification';
import deleteNotification from './deleteNotification';
import markAllNotification from './markAllNotification';
import loadNotificationTypes from './loadNotificationTypes';
import loadDocumentTypes from './loadDocumentTypes';

export default function* watchClient() {
  yield takeEvery(AUTHORIZED_MODULE + MARK_ALL, markAllNotification);
  yield takeEvery(SYSTEM_MODULE + INIT_APP, initKeyCloak);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION, authorizedRegistration);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, authorizedLogin);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT, authorizedLogout);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED, authorizedLogout);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK, authorizedCheck);
  yield takeEvery(AUTHORIZED_MODULE + FORGOT_PASSWORD, forgotPassword);
  yield takeEvery(AUTHORIZED_MODULE + REFRESH_KEY_CLOAK, refreshKeyCloak);
  yield takeEvery(AUTHORIZED_MODULE + UPDATE_PASSWORD, updatePassword);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_NOTIFICATION, loadNotification);
  yield takeEvery(AUTHORIZED_MODULE + DELETE_NOTIFICATION, deleteNotification);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES, loadNotificationTypes);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_DOCUMENT_TYPES, loadDocumentTypes);
}
